import { ColumnElement } from '@typedream/core';
import {
  getChildren,
  getNode,
  setNodes,
  toDOMNode,
  withoutNormalizing,
} from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../../types';

const columnItemPaddings = 30;

export const setColumnItemsWidthToFitContent = (
  editor: DreamEditor,
  path: Path,
) => {
  const node = getNode<ColumnElement>(editor, path);

  if (!node) return;

  if (node.type !== 'column') return;

  const domNode = toDOMNode(editor, node);

  if (!domNode) return;

  const columnActualWidth = domNode.getBoundingClientRect().width;

  withoutNormalizing(editor, () => {
    getChildren([node, path]).forEach(([columnItemElement, columnItemPath]) => {
      const widestWidth = columnItemElement.children.reduce((acc, element) => {
        const width = toDOMNode(editor, element)?.getBoundingClientRect()?.width || 0;
        return width > acc ? width : acc;
      }, 0);

      // set column item width to widest width of it's children plus column item horizontal paddings
      const width = widestWidth + columnItemPaddings;
      const widthAsRatio = width / columnActualWidth;

      setNodes(editor, { width: widthAsRatio }, { at: columnItemPath });
    });
  });
};
